// extracted by css-extract-rspack-plugin
export default {"container":"_da37c26a"};